import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./components/top-navigation/topnavigator.css";
import "./components/side-navigation/sidenav.css";
import "./components/footer/footer.css";
import "./views/signup/signup.css";
import "./views/jobs/job.css";
import "./views/landing/landingpage.css";
import "./views/login/login.css";
import "./views/payment-link/paymentlink.css";
import "./views/pricing/pricing.css";
import "./views/products/product.css";
import "./views/swop/swop.css";
import "./views/guide/guide.css";
import "./views/direct-debit/directdebit.css";
import "./views/contact-sales/contactsales.css";
import "./views/api-status/apistatus.css";
import "./views/compliance/compliance.css";
import "./components/api-status/footer/apistatusfooter.css";
import "./components/api-status/api-status-indicator/statusindicator.css"
import "./components/api-status/history/history.css"
import "./components/api-status/live-updates/liveupdates.css";
import "./components/business-products/businessproducts.css";
import App from "./App";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
